/* eslint-disable object-curly-newline */
import subscriptionApi from '@/api/subscription';
import {
  storeActionCommit,
} from '@/utils/common-utils';

export default {
  fetchSubscriptions({ commit }, { type, errorManagementType }) {
    return subscriptionApi.fetchSubscriptions(type, errorManagementType)
      .then(storeActionCommit(commit, 'setSubscriptions'));
  },
};
